module.exports = __webpack_public_path__ + "static/media/ic_avatar_placeholder.d168485e.svg";